namespace GeniuzPOS.Purchase {
    export class ReportPendingPOColumns {
        static columnsKey = 'Purchase.ReportPendingPO';
    }
}
